import type { Release } from '../releases';

export default {
  id: '2026-11-02-pilot-project-money',
  at: '2026-11-02T09:09:00Z',
  title: 'Pilot показывает суммы проекта тем, у кого есть уровень денег на этот проект',
  modules: ['ai'],
  items: [
    'Если вам открыт уровень денег на отдельный проект, ответы Pilot о записях этого проекта больше не скрывают суммы. По другим проектам действует ваш общий уровень, как и раньше.',
  ],
  why: 'Pilot сверял суммы только с общим уровнем денег, поэтому руководитель проекта с правом на суммы своего проекта видел в ответах «сумма скрыта».',
  link: '/support',
} satisfies Release;
